<template>
  <div class="host">
    <slot name="activator" :on="on"></slot>
    <div v-if="value" class="vm-dialog-content">
      <transition name="bounce" appear>
        <div class="vm-dialog" v-click-outside="off">
          <slot />
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import ClickOutside from '@app/directives/click-outside.directive';

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    }
  },
  directives: { ClickOutside },
  watch: {
    value(show) {
      if (show) {
        document.documentElement.classList.add('vm-global-scrollblock');
      } else {
        document.documentElement.classList.remove('vm-global-scrollblock');
      }
    }
  },
  destroyed() {
    document.documentElement.classList.remove('vm-global-scrollblock');
  },
  methods: {
    on() {
      this.$emit('input', true);
    },
    off() {
      this.$emit('input', false);
    }
  }
};
</script>

<style scoped>
.vm-dialog-content {
  position: fixed;
  z-index: 4;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  align-items: center;
  display: flex;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.35);
}
.vm-dialog {
  background-color: #fff;
  box-shadow: 0 11px 15px -7px rgba(0, 0, 0, 0.2),
    0 24px 38px 3px rgba(0, 0, 0, 0.14), 0 9px 46px 8px rgba(0, 0, 0, 0.12);
  border-radius: 3px;
  max-height: 100vh;
  overflow: auto;
}
.bounce-enter {
  opacity: 0;
  transform: scale(0);
}
.bounce-enter-active {
  animation: bounce-in 100ms;
}
@keyframes bounce-in {
  0% {
    opacity: 0;
    transform: scale(0);
  }
  100% {
    opacity: 1;
    transform: scale(1);
  }
}
</style>
